import axios from "axios";
import Swal from "sweetalert2";
import { getVendorSettings } from "../services/helper";
import { toast } from "react-toastify";

export const handlePrinting = async (
  order_data,
  printOptions = { receipt: true, label: true }
) => {
  const {
    id: invoice_id,
    items = [],
    discount = 0,
    tax = 0,
    sale_amount = 0,
    paid = 0,
    tax_apply = false,
    redeem_points_value = 0,
    split_payment,
  } = order_data;

  localStorage.setItem("latestOrder", JSON.stringify(order_data));

  const printerAPI = process.env.REACT_APP_PRINT_API;
  const receiptPrinter = localStorage.getItem("tbo_receipt_printer_name");
  const labelPrinter = localStorage.getItem("tbo_label_printer_name");

  const subtotal = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const {
    showStoreAddress,
    showStoreEmail,
    showStoreLogo,
    showStoreName,
    showStorePhone,
    headerNote,
    footerNote,
  } = getVendorSettings("receiptTemplate");

  const vendor_email = showStoreEmail ? getVendorSettings("email") : null;
  const vendor_store_name = showStoreName
    ? getVendorSettings("store_name")
    : null;

  const vendor_address = showStoreAddress
    ? getVendorSettings("vendor_contact_address")
    : null;
  const vendor_phone = showStorePhone
    ? getVendorSettings("vendor_contact_phone")
    : null;
  const vendor_logo = showStoreLogo
    ? `${window.location.origin}/assets/images/logo/logo.png`
    : null;

  const receipt_option = getVendorSettings("receipt_print_option") || "always";
  const label_option = getVendorSettings("label_print_option") || "never";

  const redirectToPrintPage = (url, target = "_blank") => {
    window.open(url, target);
  };

  const normalizedCart = items.map((item) => ({
    ...item,
    name: item.print_name || item.name, // Use print_name if available, otherwise use original name
    addons:
      typeof item.addons === "string" ? JSON.parse(item.addons) : item.addons,
  }));

  // --- ✅ Receipt Print ---
  if (printOptions.receipt && receipt_option !== "never") {
    let shouldSkipReceipt = false;

    if (receipt_option === "prompt") {
      const result = await Swal.fire({
        title: "Print Invoice?",
        text: "Would you like to print the invoice?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, print it!",
        cancelButtonText: "No",
      });
      if (!result.isConfirmed) shouldSkipReceipt = true;
    }

    if (receipt_option === "default" && !shouldSkipReceipt) {
      redirectToPrintPage(`/pos/invoice`);
    } else if (!shouldSkipReceipt && receipt_option !== "default") {
      if (!receiptPrinter) {
        return Swal.fire(
          "Printer Not Set",
          "Please select a receipt printer",
          "error"
        );
      }

      try {
        await axios.post(`${printerAPI}/print`, {
          invoice_id,
          printerName: receiptPrinter,
          logo: vendor_logo,
          vendor_email,
          vendor_store_name,
          vendor_address,
          vendor_phone,
          headerNote,
          footerNote,
          subtotal,
          discount,
          tax,
          tax_apply,
          paid: order_data.customer_paid || paid,
          order_total: paid,
          redeem_points_value,
          cartItems: normalizedCart,
          split_payment,
          printerOptions: {
            preview: false,
            silent: true,
            printerName: receiptPrinter,
            pageSize: "78mm",
            margin: "0 0 0 0",
            timeOutPerLine: 400,
            copies: 1,
          },
        });

        toast.info(`Invoice printed: ${invoice_id}`);
      } catch (err) {
        console.error(err);
        Swal.fire(
          "Receipt Print Failed",
          "Could not send to receipt printer",
          "error"
        );
      }
    }
  }

  // --- ✅ Label Print ---
  if (printOptions.label && label_option !== "never") {
    let shouldSkipLabel = false;

    if (label_option === "prompt") {
      const result = await Swal.fire({
        title: "Print Labels?",
        text: "Would you like to print the labels?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, print them!",
        cancelButtonText: "No",
      });
      if (!result.isConfirmed) shouldSkipLabel = true;
    }

    if (label_option === "default" && !shouldSkipLabel) {
      redirectToPrintPage(`/print/label`);
      return;
    }

    if (shouldSkipLabel) return;

    if (!labelPrinter) {
      return Swal.fire(
        "Label Printer Not Set",
        "Please select a label printer",
        "error"
      );
    }

    try {
      for (const item of normalizedCart) {
        const labelQty = item.quantity || 1;

        const basePayload = {
          printerName: labelPrinter,
          vendor_store_name,
          vendor_address,
          logo: vendor_logo,
          item_name: item.print_name || item.name,
          addons: item.addons,
          printerOptions: {
            preview: false,
            silent: true,
            printerName: labelPrinter,
            pageSize: "68mm",
            margin: "0 0 0 0",
            timeOutPerLine: 300,
            copies: 1,
          },
        };

        for (let i = 0; i < labelQty; i++) {
          await axios.post(`${printerAPI}/label`, basePayload);
        }
      }

      toast.success("Labels printed successfully");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Label Print Failed",
        "Could not send to label printer",
        "error"
      );
    }
  }
};
